"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elmer_common_1 = require("elmer-common");
exports.getContext = function (target, defineRules, saveAttrKey) {
    var attrKey = !elmer_common_1.StaticCommon.isEmpty(saveAttrKey) ? saveAttrKey : "contextStore";
    var contextData = target[attrKey] || {};
    var contextResult = {};
    if (defineRules) {
        // tslint:disable-next-line: forin
        for (var key in defineRules) {
            var dRule = defineRules[key];
            var dData = elmer_common_1.StaticCommon.getValue(contextData, key);
            if (dData !== undefined) {
                contextResult[key] = dData;
            }
            if (typeof dRule.rule === "function") {
                if (!dRule.rule(dData)) {
                    // tslint:disable-next-line: no-console
                    console.error(key + "\u5B9A\u4E49\u7C7B\u578B\u548CContextStore\u6570\u636E\u4E0D\u5339\u914D!");
                }
            }
        }
    }
    return contextResult;
};
